import api from './api';

// Troubleshoot Token is used for troubleshooting mode in the Management Panel
export const TROUBLESHOOT_TOKEN = 'troubleshoot_token';

const registerAuth = ({ username, password, re_password, member, mentor, organization, program }) =>
  api.post('/api/credentials/users/', {
    username: String(username).toLowerCase(), // Making sure the email is lower case.
    password,
    re_password,
    member,
    mentor,
    organization,
    program,
  });

const forgotPassword = email =>
  api.post('/api/credentials/users/reset_password/', {
    email: String(email).toLowerCase(), // Making sure the email is lower case.
  });

const resetPassword = ({ uid, token, user, password }) =>
  api.post('/api/credentials/users/reset_password_confirm/', {
    new_password: password,
    uid,
    token,
    user,
  });

const setNewPassword = ({ re_new_password, new_password, current_password }) =>
  api.post('/api/credentials/users/set_password/', {
    current_password,
    new_password,
    re_new_password,
  });

export default {
  forgotPassword,
  registerAuth,
  resetPassword,
  setNewPassword,
};
